export const SettingsPlugin = (settings) => {
    return {
        install (Vue) {
            Vue.prototype.$settings = settings
        }
    }
}
